module.exports = __webpack_public_path__ + "static/boykeepsakebox-2be944adeb1226a2092f0856f3f825a5.png";